export default {
      id: "upload-usage",
      viewBox: "0 0 16 20",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#upload",
      toString: function () {
        return this.url;
      }
    }